import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faLine } from "@fortawesome/free-brands-svg-icons/faLine";
import { SvgIconComponent } from "angular-svg-icon";

@Component({
  selector: "icon",
  standalone: true,
  imports: [CommonModule, MatIconModule, FontAwesomeModule, SvgIconComponent],
  template: `
    @if (isFaIcon()) {
    <fa-icon
      [icon]="faIcons[icon()]"
      [attr.data-testid]="'font-awesome-icon'"
    ></fa-icon>
    } @else if (isSvgFile()) {
    <svg-icon
      class="inline-block"
      [src]="icon()"
      [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"
      [attr.data-testid]="'svg-icon'"
    >
    </svg-icon>
    } @else {
    <mat-icon [attr.data-testid]="'material-icon'"> {{ icon() }} </mat-icon>
    }
  `,
  host: {
    class: "inline-block h-6 w-6",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  public icon = input("");

  public faIcons: { [key: string]: IconDefinition } = {
    "fa-facebook": faFacebook,
    "fa-line": faLine,
  };

  public isSvgFile = computed(() => {
    const icon = this.icon();
    return icon.startsWith("/") || icon.startsWith(".");
  });

  public isFaIcon = computed(() => {
    const icon = this.icon();
    return icon.startsWith("fa-");
  });
}
